<template>
  <el-dialog title="能耗计划设置" :visible.sync="dialogVisible" width="850px" :before-close="beforeClose">
    <div class="" style="height:40vh">
      <div class="date row-center" style="justify-content:space-between;">
        <div class="month">
          <span v-for="item in month" :class="{ active: active == item }" @click="active = item">{{ item }}月</span>
        </div>

      </div>
      <div class="cont">
        <table>
          <tr>
            <!-- <th width="15%">区域</th> -->
            <th>用电限额（kWh）</th>
            <th>用水限额（m³）</th>
            <th>用热限额（GJ）</th>
            <th>用冷限额（GJ）</th>
          </tr>
          <tr>
            <!-- <td>{{ $store.state.project.projectInfo.projectName }}</td> -->
            <td>
              <el-input v-model="form.electric" placeholder="未设置" class="einput"></el-input>
            </td>
            <td>
              <el-input v-model="form.water" placeholder="未设置" class="einput"></el-input>
            </td>
            <td>
              <el-input v-model="form.heat" placeholder="未设置" class="einput"></el-input>
            </td>
            <td>
              <el-input v-model="form.cooling" placeholder="未设置" class="einput"></el-input>
            </td>
          </tr>
        </table>
      </div>
      <div class="date-bottom row-center">
        <div class="clear" @click="clearPlan()">清空本月计划</div>
        <el-button type="primary" class="btn" @click="seavePlan()">保存</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { conservationPlan, listSaveOrUpdate, treeBuilding, saveOrUpdate, conservationPlanSingle,projectConservationPlan } from "../../../api/power";
import {
  dateFormat,
} from "../../../util/DateUtil";
export default {
  props: {
    dialogVisible: Boolean,
  },
  data() {
    return {
      month: [],
      active: new Date().getMonth() + 1,
      form: {
        electric: "",
        water: "",
        heat: "",
        cooling: "",
      }
    };
  },
  watch: {
    active() {
      this.GetTreeData();
    }
  },
  computed: {

  },
  mounted() {
    for (let index = 1; index <= 12; index++) {
      this.month.push(index);
    }
    this.GetTreeData();
  },
  methods: {
    //查询
    GetTreeData() {
      let obj = {
        month: this.active,
        projectId: this.$store.state.project.currentProject.projectId,
        year: new Date().getFullYear(),
        // buildingId: 0
      }
      projectConservationPlan(obj).then((res) => {
        this.form = res.data.data.plan?res.data.data.plan:{};
        this.form.id = res.data.data.building.id
      });
    },
    //保存
    seavePlan() {
      let obj = {
        buildingId: this.form.id,
        "cooling": this.form.cooling?this.form.cooling:"",
        "electric": this.form.electric?this.form.electric:"",
        "heat": this.form.heat?this.form.heat:"",
        "water": this.form.water?this.form.water:"",
        "month": this.active,
        "projectId": this.$store.state.project.currentProject.projectId,
        "year": dateFormat("YY", new Date()),
        id: this.form.id
      }
      saveOrUpdate(obj).then((res) => {
        if (res.data.status) {
          this.$message({
            message: '提交成功！',
            type: 'success'
          });
          this.$emit("handleClose", false);
          this.GetTreeData();
        } else {
          this.$message.error('提交失败！');
        }
      });
    },
    //清空计划
    clearPlan() {
      this.form = []
    },
    beforeClose() {
      this.$emit("handleClose", false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 0 !important;
}
.cont{
  // border-bottom: 1px solid #e9eaec;
  // height:60%;
  table {
    border-collapse: collapse;
    width: 100%;

    tr {
      th {

        background: rgba(0, 43, 102, .06);
        font-size: 18rem;
        font-weight: 700;
        height: 40px;
        text-align: center;
        color: #333333;
      }
    }

    .einput {
      width: 90%;
    }

    tr {
      td {
        font-size: 18rem;
        // border-bottom: 1px solid #e9eaec;
        height: 60px;
        text-align: center;
      }
    }
  }

}

.pagination {
  text-align: center;
  padding: 20px;
  position: absolute;
  bottom: 0;
  width: 100%;

  .el-button {
    padding: 8px 20px;
  }

  .size {
    width: 100px;
    display: inline-block;
  }
}

.date {
  padding: 20rem;
  .month {
    span {
      width: 64rem;
      height: 36rem;
      background: rgba(0, 43, 102, 0.06);
      border-radius: 4rem;
      display: inline-block;
      text-align: center;
      line-height: 36rem;
      margin-right: 5rem;
      font-size: 18rem;
      cursor: pointer;
    }

    .active {
      background: #0D94FF;
      color: #fff
    }
  }

 
}
.date-bottom{
  border-top: 1px solid #e9eaec;
  padding: 20rem;
  text-align: center;
  padding: 20px;
  position: absolute;
  bottom: 0;
  width: 100%;
  .clear {
    border: 1px solid #CCCCCC;
    border-radius: 4rem;
    color: #666666;
    height: 36rem;
    font-size: 16rem;
    cursor: pointer;
    line-height: 36rem;
    padding: 0 10px;
  }

  .btn {
    height: 32px;
    width: 66px;
    text-align: center;
    line-height: 32px;
    padding: 0;
    margin-left: 10px;
  }
}
</style>
